import { gql } from '@apollo/client'

export const VERIFY_MFA_CODE = gql`
  mutation verifyMfaCode($code: VerifyMfaCodeInput!) {
    verifyMfaCode(input: $code) {
      accessToken
      refreshToken
      passwordExpired
    }
  }
`
export const CHANGE_USER_PASSWORD = gql`
  mutation changeUserPassword($input: ChangeUserPasswordInput!) {
    changeUserPassword(input: $input)
  }
`
